import { Component, OnInit, OnChanges, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { ConfigService } from '../../services/config/config.service';
import { DataService } from '../../services/data/data.service';
import { DisplayService } from '../../services/display/display.service';
import { SmartContractService } from '../../services/smart-contract/smart-contract.service';

@Component({
	selector: 'pcm-modal-form',
	templateUrl: './modal-form.component.html',
	styleUrls: ['./modal-form.component.scss']
})
export class ModalFormComponent implements OnInit, OnChanges, OnDestroy {

	@Input() aclOverwrite = false;
	@Input() onlyEdits = false;
	@Input() onlyApprovals = false;
	@Input() alsoEdits = false;
	@Input() allowClose = false;
	@Input() forceApply = true;
	@Input() commentPlaceholder = '';
	@Input() allowDelete = false;
	@Input() tableService: any = {};
	@Input() tableTab = {};
	@Input() pageHelp = '';

	@Output() modalSubmit: EventEmitter<any> = new EventEmitter();
	@Output() modalApprove: EventEmitter<any> = new EventEmitter();
	@Output() modalDelete: EventEmitter<any> = new EventEmitter();

	modalVisible = false;
	modalTable = false;
	dataConfig;
	modalProp = '';
	formData = {};
	relatedData = [];
	tableHelp = '';
	columnsConfig = [];
	selectedTableRows = [];

	originalInputs;

	// this form is to support the popup fired by bulk table actions
	constructor(
		public configService: ConfigService,
		public dataService: DataService,
		public displayService: DisplayService,
		public smartContractService: SmartContractService
	) { }

	ngOnInit() {
		console.log('MODAL FORM INIT', this.aclOverwrite, this.onlyEdits, this.onlyApprovals, this.alsoEdits, this.allowClose, this.tableService['dataObj']);
		this.dataService.clearContractorNodes();
		this.originalInputs = {
			aclOverwrite: this.aclOverwrite,
			onlyEdits: this.onlyEdits,
			onlyApprovals: this.onlyApprovals,
			alsoEdits: this.alsoEdits,
			allowClose: this.allowClose
		};
		if (this.modalTable) {
			this.columnsConfig = this.configService.getTableFields(this.tableService['dataObj'], true);
		}
	}

	ngOnChanges(event) {
	}

	ngOnDestroy() {
		this.aclOverwrite = false;
		this.onlyEdits = false;
		this.onlyApprovals = false;
		this.alsoEdits = false;
		this.allowClose = false;
		this.commentPlaceholder = '';
		this.allowDelete = false;
		this.tableService = {};
		this.tableTab = {};
		this.pageHelp = '';
	}

	showModal(basicData, scDataObj, relatedData) {
		console.log('SHOW MODAL', basicData, scDataObj, relatedData, this.originalInputs);
		this.aclOverwrite = this.originalInputs.aclOverwrite;
		this.onlyEdits = this.originalInputs.onlyEdits;
		this.alsoEdits = this.originalInputs.alsoEdits;
		this.allowClose = this.originalInputs.allowClose;
		this.clearFormData();
		const formConfig = this.configService.getDataObj(scDataObj);
		this.modalProp = basicData.prop;
		this.relatedData = relatedData;
		this.dataConfig = this.smartContractService.getSCConfig(formConfig, this.modalProp);
		this.checkAfterSubmit();
		this.populateModalForm();
		this.modalVisible = true;
		console.log('SHOW MODAL', this.alsoEdits, this.modalProp, this.dataConfig, this.formData);
	}

	getPageName() {
		let pageName = '';
		if (!this.modalTable) {
			pageName = this.dataConfig.name;
		}
		return pageName;
	}

	getTableName() {
		let tableName = '';
		if (this.modalTable) {
			tableName = this.dataConfig.name;
		}
		return tableName;
	}

	tableClick(event) {
		console.log('MODAL TABLE CLICK: ', event);
	}

	tableSelect(event) {
		console.log('MODAL TABLE SELECT: ', event);
		this.selectedTableRows = event.selected;
	}

	tablePage(event) {
		console.log('MODAL TABLE PAGE: ', event);
	}

	checkAfterSubmit() {
		if (this.alsoEdits) {
			// since modal is for smart contracts only...
			// when alsoEdits is active (smart contracts list page)...
			// we only want to show edits if editable after submitsion
			this.alsoEdits = false;
			const self = this;
			this.dataConfig.fields.forEach(function (d, i) {
				if (d['afterSubmit'] === true && d['edit'] === true) {
					// currently modal is for smart contracts only so we can...
					// if any fields are editable after submission allow alsoEdits
					self.alsoEdits = true;
				}
			});
		}
	}

	clearFormData() {
		this.formData = {};
	}

	formCancel(event) {
		this.modalVisible = false;
	}

	formDelete(event) {
		console.log('FORM DELETE', event);
		const modalEvent = {
			event: event.event,
			prop: this.modalProp,
			data: event.data
		};
		this.modalDelete.emit(modalEvent);
	}

	formSubmit(event) {
		console.log('FORM SUBMIT', event);
		const modalEvent = {
			event: event.event,
			prop: this.modalProp,
			data: event.data
		};
		this.modalSubmit.emit(modalEvent);
	}

	approveContent(event) {
		const approvalData = event.data;
		approvalData['approval'] = {
			approvalstatus: this.configService.smartContractApprovalStatus,
			rejectioncomment: ''
		};
		const modalEvent = {
			event: event.event,
			prop: this.modalProp,
			data: approvalData
		};
		console.log('MODAL APPROVE', event, approvalData);
		this.modalApprove.emit(modalEvent);
	}

	populateModalForm() {
		console.log('MODAL FORM CONFIG', this.dataConfig, this.relatedData);

		const modalFormData = {};
		const self = this;

		// for each of the data config nested objects
		self.dataConfig.objects.forEach(function (dataObj, dataObjI) {
			console.log('POPULATE MODAL FORM OBJECT', dataObj.prop);
			// create an array using the nested object's prop param
			modalFormData[dataObj.prop] = [];

			// then loop through each item in the related data array (selected table rows)
			self.relatedData.forEach(function (relatedItem, relatedItemI) {

				// create an empty object to populate with the autopop params
				const relatedItemData = {};

				// loop through each of the nested object's fields and populate the new object accordingly
				dataObj.fields.forEach(function (dataField, dataFieldI) {

					// console.log('AUTO POP FIELD:', d.prop);
					if (relatedItem.autoPop === '') {
						relatedItemData[dataField.prop] = '';
					} else {
						const popArr = dataField.autoPop.split(':');
						if (popArr[2] === undefined) {
							relatedItemData[dataField.prop] = relatedItem[popArr[1]];
						}
						if (popArr[2] !== undefined && popArr[3] === undefined) {
							relatedItemData[dataField.prop] = relatedItem[popArr[2]];
						}
						if (popArr[3] !== undefined) {
							relatedItemData[dataField.prop] = relatedItem[popArr[2]][popArr[3]];
						}
					}
				});

				// push the new object created from each selected table row
				// into the array named after the data objects prop param
				modalFormData[dataObj.prop].push(relatedItemData);

			});

		});

		// for each of the data config fields
		self.dataConfig.fields.forEach(function (d, i) {
			// create a data property if it is undefined
			if (modalFormData[d.prop] === undefined) {
				modalFormData[d.prop] = '';
			}
			// special init for assigning DTV permanently
			if (d.prop === self.configService.dtvPermanentProp) {
				modalFormData[d.prop] = true;
			}
		});

		if (self.relatedData[0]['rules'] !== undefined && self.relatedData.length === 1) {
			self.dataConfig.fields.forEach(function (d, i) {
				// create a data property if it is undefined
				if (self.relatedData[0]['rules'][d.prop] !== undefined && self.relatedData[0]['rules'][d.prop] !== '') {
					modalFormData[d.prop] = self.relatedData[0]['rules'][d.prop];
				}
			});
		}

		console.log('MODAL FORM DATA', modalFormData);
		this.formData = modalFormData;
	}

}
